import { useParams, useNavigate } from "react-router-dom";
import { useState, useRef, useCallback } from "react";
import { Divider, Row, Col, Button, Table, Input, InputNumber, Spin, 
        Space, Dropdown, Tooltip, message, Pagination, Select, Checkbox } from "antd";
import { getLabAssignmentReport, updateLabAssignmetReport, getAiCodeFeedback } from '../../services/ide-apis';
import { trackEvent, formatDateMonth, isMobile, getIdeProjectTypeMetaData } from '../utils/util-functions';
import { ReactComponent as MoreIcon } from '../../assets/logos/more icon.svg';
import { global_var } from "../../services/cs-lab-config";
import ProjectFilters from "../utils/project-filters";
import { ReactComponent as ShowCode } from '../../assets/logos/show code.svg';
import { ReactComponent as ViewSourceCode } from '../../assets/logos/viewSourceCode.svg';
import SourceCodeModal from '../labAssignments/view-source-code-modal';
import BackBtn from '../utils/back-btn';

const AIAutoBulkEvaluate = () => {
    const navigate = useNavigate();
    let { resourceId, labQuestionMappingId } = useParams();
    const [report, setReport] = useState({});
    const [isCompletedLoading, setIsCompletedLoading] = useState(true);

    const [saveLoader, setSaveLoader] = useState(false);
    const [questionTitle, setQuestionTitle] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [studentMappings, setStudentMappings] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [modifiedData, setModifiedData] = useState([]);
    const [completedKey, setCompletedKey] = useState(0);
    const [completedPageNo] = useState(1);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [dropdownClicked, setDropdownClicked] = useState(false);
    const [completedDataCount, setCompletedDataCount] = useState(0);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [currentRecord, setCurrentRecord] = useState([]);
    const [projectType, setProjectType] = useState();
    const [showScoreColumn, setShowScoreColumn] = useState(false);

    const fetchSubmittedDataRef = useRef(fetchSubmittedData);
    let exportDataRef = useRef({});

    const filtersChanged = useCallback((filters) => {
        exportDataRef.current = {
            ...filters,
            fkCompanyId: global_var.company_id,
            from: "csLab"
          };

        fetchSubmittedDataRef.current(completedPageNo);
        
    }, [completedPageNo]);
    
    function fetchSubmittedData(completedPageNo, isRedirect){
        setIsCompletedLoading(true)                  
        exportDataRef.current.filteredData = {evaluated: false, submitted: true, pending: false, resubmit:false};
        exportDataRef.current.pageNo = completedPageNo;
        exportDataRef.current.limitCount = 10;
        getLabAssignmentReport(resourceId,labQuestionMappingId,exportDataRef.current).then((response) => {
            response = response.data
            if (response.statusCode === 200) {
                report['completed'] = {}
                if (response.reportObj && response.reportObj.organizedData) {
                    report['completed'] = response.reportObj.organizedData.completed;
                    if(response.reportObj.organizedData.completed){
                        const allStudentIds = report.completed.map(student => student._id);
                        setSelectedStudents(allStudentIds);  
                        if ( response.reportObj.organizedData.completed &&
                            response.reportObj.organizedData.completed.length > 0 &&
                            response.reportObj.organizedData.completed[0].totalMark) {
                            setShowScoreColumn(true); 
                        }
                    }
                    setReport(report);
                    setCompletedKey(completedKey + 1);
                    setCompletedDataCount(response.reportObj.categoryCount)
                }
                setCompletedDataCount(response.reportObj.categoryCount)
                setQuestionTitle(response.reportObj.questionTitle)
                setSelectedDate(response.reportObj.createdDate)
                setSelectedClass(response.reportObj.currentClass)
                if (response?.reportObj?.studentMappings) {
                    setStudentMappings(response.reportObj.studentMappings);
                }
                setProjectType(response.reportObj.projectType)
                setIsCompletedLoading(false)    
                if (isRedirect && response.reportObj && Object.keys(response.reportObj).length === 0) {
                    navigate(-1);
                }    
            }
        })
    }
    function renderMappings(studentMappings, transform) {
        let text = '';
        studentMappings.forEach((mapping, index) => {
            if(mapping.className ){
            text = text + ' ' + mapping.className + ' '
            }
            if(mapping.divisionName){
                text = text + ' ' + mapping.divisionName  + ' ';
            }
            if(mapping.streamName){
                text = text + ' ' + mapping.streamName  + ' ';
            }
            if (mapping.individualStudents && Array.isArray(mapping.individualStudents)) {
                mapping.individualStudents.forEach((student, studentIndex) => {
                    text += ' ' + student.Name; 
                    if (studentIndex < mapping.individualStudents.length - 1) {
                        text += ' , '; 
                    }
                });
            }
            if(index < studentMappings.length -1){
                text = text + ', '
            }
        });

        if(transform && text.length > 40 ){
            text = text.slice(0, 40) + '... ';
        }
        return text;
    }

    const handleSelectAllChange = (e) => {
        const checked = e.target.checked;
        setSelectAllChecked(checked);

        const allStudentIds = report.completed.map(student => student._id);
        setSelectedStudents(checked ? allStudentIds : []);
    };

    const handleCheckboxChange = (record) => {
        const { _id } = record;
        const selectedIndex = selectedStudents.indexOf(_id);
        let newSelectedStudents = [];

        if (selectedIndex === -1) {
            newSelectedStudents = [...selectedStudents, _id];
        } else {
            newSelectedStudents = [...selectedStudents.slice(0, selectedIndex), ...selectedStudents.slice(selectedIndex + 1)];
        }
        
        setSelectedStudents(newSelectedStudents);
        setSelectAllChecked(newSelectedStudents.length === report.completed.length);
    };

    const generateItems = (record) => [
        {
            label: <Button className="cancel-button" style={{width:'160px'}}>Clear Feedback</Button>,
            key: '1',
            onClick: () => handleClearFeedback(record),
        },
        {
            label: <Button className="cancel-button"  style={{width:'160px'}}>Restore AI Feedback</Button>,
            key: '2',
            onClick: () => handleAiFeedback(record),
        },
    ];

    const columns = [
        {
            title: (
                <Checkbox
                    checked={selectAllChecked}
                    onChange={handleSelectAllChange}
                />
            ),
            dataIndex: 'select',
            key: 'select',
            width: 40,
            render: (_, record) => (
                <Checkbox
                    checked={selectedStudents.includes(record._id)}
                    onChange={() => handleCheckboxChange(record)}
                />
            ),
        },
        {
            title: 'Student Name',
            dataIndex: 'name',
            key: 'name',
            width:220,
            showInExpandable:true,
            render: (_, record) => {
                return (
                    <span>
                        <span className="poppins-regular" style={{fontSize:'14px',color:'#404040'}}>{record.name}</span>
                        {selectedClass &&(
                            <p className="text-midgrey poppins-regular">
                            {record.class && <span>{' '} <span style={{color:'#111111',fontSize:'14px'}}>{record.class}</span></span>}
                            {record.division && <span>{' '} <span style={{color:'#111111'}}>{record.division}</span></span>}</p>
                        )}
                    </span>
                );
            },
        },
    ]
    if (showScoreColumn) {
    columns.push(
        {
            title: 'Score',
            dataIndex: 'markScored',
            key: 'markScored',
            width: 40,
            showInExpandable:true,
            render: (score, record) => 
            <div>
                {isMobile && <span className="poppins-regular" style={{fontSize:'16px'}}>Score </span>}
                <InputNumber
                    className="poppins-regular"
                    style={{ width: '45px'}}
                    defaultValue={score}
                    onChange={(defaultValue) => handleInputChange(defaultValue, 'markScored', record._id)}
                    max={record.totalMark ? record.totalMark : undefined}
                    min={0} 
                    onKeyPress={(e) => {
                        if (!/^\d$/.test(e.key)) {
                            e.preventDefault();
                        }
                    }}
                />
            </div>
        }
    )}
    columns.push(
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 130,
            showInExpandable:true,
            render: (_, record) => {
                return (
                    <Select
                        onChange={(defaultValue) => handleInputChange(defaultValue, 'evaluationStatus', record._id)}
                        placeholder="Please select a status"
                        className="mb-2"
                        style={{ width: "80%", borderColor:'#D7BEF7' }}
                        options={[
                            { value: "Evaluated", label: "Evaluated" },
                            { value: "Ask for resubmission", label: "Ask for resubmission" },
                            { value: "Pending evaluation", label: "Pending evaluation" },
                        ]}
                        defaultValue={{ value: "Evaluated", label: "Evaluated" }}
                    />
                );
            },
        },
        {
            title: 'Feedback/Error',
            dataIndex: 'evaluationFeedback',
            key: 'evaluationFeedback',
            showInExpandable:false,
            width: 220,
            render: (feedback, record) => (
                <Input.TextArea
                    className="poppins-regular"
                    rows={4}
                    defaultValue={feedback}
                    onChange={(event) => handleInputChange(event.target.value, 'evaluationFeedback', record._id)}
                    style={{borderColor:'#D7BEF7',fontSize:'12px',color:'#404040'}}
                />
            ),
        },
        {
            title: 'Improvement',
            dataIndex: 'evaluationImprovement',
            key: 'evaluationImprovement',
            showInExpandable:false,
            width: 220,
            render: (improvement, record) => (
                <Input.TextArea
                    className="poppins-regular"
                    defaultValue={improvement}
                    rows={4}
                    onChange={(event) => handleInputChange(event.target.value, 'evaluationImprovement', record._id)}
                    style={{fontSize:'12px',color:'#404040'}}
                />
            ),
        },
    )

    if(projectType !== 'vc3' && projectType !== 'sql2'){

        columns.push(
            {
                showInExpandable: true,
                width: 40,
                render: (_, record) => {
                    const isExpanded = expandedRowKeys.includes(record._id);
                    if (isMobile && isExpanded) {
                        return (
                            <Space size="small">
                                <Tooltip title={'Open Project'}>
                                    <span onClick={() => navigateToIDE(record)}>
                                        <ShowCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>

                                <Tooltip title={'View Code'}>
                                    <span onClick={() => handleOpenModal(record)}>
                                        <ViewSourceCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>
                                
                                <Tooltip title={'More'}>
                                    <Dropdown
                                        menu={{ items: generateItems(record) }}
                                        trigger={["click"]}
                                        onClick={() => setDropdownClicked(true)}
                                    >
                                        <span onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                <MoreIcon style={{ cursor: 'pointer' }} />
                                            </Space>
                                        </span>
                                    </Dropdown>
                                </Tooltip>
                            </Space>
                        );
                    } else if (!isMobile) {
                        return (
                            <Space size="small">
                                <Tooltip title={'Open Project'}>
                                    <span onClick={() => navigateToIDE(record)}>
                                        <ShowCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>

                                <Tooltip title={'View Code'}>
                                    <span onClick={() => handleOpenModal(record)}>
                                        <ViewSourceCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>

                                <Tooltip title={'More'}>
                                    <Dropdown
                                        menu={{ items: generateItems(record) }}
                                        trigger={["click"]}
                                        onClick={() => setDropdownClicked(true)}
                                    >
                                        <span onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                <MoreIcon style={{ cursor: 'pointer' }} />
                                            </Space>
                                        </span>
                                    </Dropdown>
                                </Tooltip>
                            </Space>
                        );
                    }
                    return null;
                },
            },
        );
    }

    if(projectType === 'sql2'){

        columns.push(
            {
                showInExpandable: true,
                width: 40,
                render: (_, record) => {
                    const isExpanded = expandedRowKeys.includes(record._id);
                    if (isMobile && isExpanded) {
                        return (
                            <Space size="small">
                                <Tooltip title={'Open Project'}>
                                    <span onClick={() => navigateToIDE(record)}>
                                        <ShowCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>
                                
                                <Tooltip title={'More'}>
                                    <Dropdown
                                        menu={{ items: generateItems(record) }}
                                        trigger={["click"]}
                                        onClick={() => setDropdownClicked(true)}
                                    >
                                        <span onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                <MoreIcon style={{ cursor: 'pointer' }} />
                                            </Space>
                                        </span>
                                    </Dropdown>
                                </Tooltip>
                            </Space>
                        );
                    } else if (!isMobile) {
                        return (
                            <Space size="small">
                                <Tooltip title={'Open Project'}>
                                    <span onClick={() => navigateToIDE(record)}>
                                        <ShowCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>
                            
                                <Tooltip title={'More'}>
                                    <Dropdown
                                        menu={{ items: generateItems(record) }}
                                        trigger={["click"]}
                                        onClick={() => setDropdownClicked(true)}
                                    >
                                        <span onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                <MoreIcon style={{ cursor: 'pointer' }} />
                                            </Space>
                                        </span>
                                    </Dropdown>
                                </Tooltip>
                            </Space>
                        );
                    }
                    return null;
                },
            },
        );
    }

    const columnsExpandable = columns.filter(col => col.showInExpandable); 


    function navigateToIDE(projectObj) {
        const projectMetaData = getIdeProjectTypeMetaData(
          projectObj.projectType
        );
        trackEvent("auto_evaluate_page_ide_button_clicked", {
          ide_project_stack_name: projectObj.projectType,
        });
    
        if (projectMetaData ? projectMetaData.route : false) {
            const fkResourceIdParam = projectObj.fkResourceId ? projectObj.fkResourceId : '';
            let url = '';

            if (projectObj.projectType === "sql2") {
                url = `${projectMetaData.route}${projectObj.queryId}?fkResourceId=${fkResourceIdParam}`;
              } else if (projectObj.projectType === "vc3") {
                url = `${projectMetaData.route}${projectObj.projectId}?isEval=true&fkResourceId=${fkResourceIdParam}`;
              } else {
                url = `${projectMetaData.route}${projectObj.projectId}`;
              }
        
            window.open(url, '_blank');
        } else {
        message.info("Coming soon.");
        }
    }
    
    const handleOpenModal = (record) => {
        setCurrentRecord(record);
        setIsOpen(true);
    };
    
    const handleInputChange = (value, dataIndex, recordKey) => {

        const existingRecordIndex = modifiedData.findIndex(record => record._id === recordKey);
        if (existingRecordIndex !== -1) {
            const updatedData = [...modifiedData];
            updatedData[existingRecordIndex] = {
                ...updatedData[existingRecordIndex],
                [dataIndex]: value
            };
            setModifiedData(updatedData);

            const updatedReport = {
                ...report,
                completed: report.completed.map(item => {
                    if (item._id === recordKey) {
                        return {
                            ...item,
                            [dataIndex]: value
                        };
                    }
                    return item;
                })
            };
            setReport(updatedReport);
        } else {
            const newRecord = {
                _id: recordKey,
                [dataIndex]: value
            };
            setModifiedData(prevData => [...prevData, newRecord]);
        }        
    };

    const handleAiFeedback = (record) => {
        getAiCodeFeedback(record.projectId).then((response) => {
            response = response.data;
            if (response.statusCode === 200) {
                let feedbackResponse = response?.aiFeedback?.feedback;
                if(response?.aiFeedback?.error != null){
                    feedbackResponse = response?.aiFeedback?.error
                }
                const updatedRecord = {
                    ...record,
                    evaluationFeedback: feedbackResponse || '',
                    evaluationImprovement: response?.aiFeedback?.improvement,
                    markScored: parseFloat(response?.aiFeedback?.score)
                };
                const recordIndex = report.completed.findIndex(item => item._id === record._id);
                if (recordIndex !== -1) {
                    const updatedEvaluated = [...report.completed];
                    updatedEvaluated[recordIndex] = updatedRecord; 
                    const updatedReport = {
                        ...report,
                        completed: updatedEvaluated
                    };
                    setReport(updatedReport); 
                    setCompletedKey(completedKey + 1);
                }

                const existingRecordIndex = modifiedData.findIndex(item => item._id === record._id);
                if (existingRecordIndex !== -1) {
                    const updatedData = [...modifiedData];
                    updatedData[existingRecordIndex] = {
                        ...updatedData[existingRecordIndex],
                        evaluationFeedback: updatedRecord.evaluationFeedback,
                        evaluationImprovement: updatedRecord.evaluationImprovement,
                        markScored: updatedRecord.markScored
                    };
                    setModifiedData(updatedData);
                } else {
                    const newRecord = {
                        _id: record._id,
                         evaluationFeedback: updatedRecord.evaluationFeedback,
                        evaluationImprovement: updatedRecord.evaluationImprovement,
                        markScored: updatedRecord.markScored
                    };
                    setModifiedData(prevData => [...prevData, newRecord]);
                }
            } else {
              message.error(response.message);
            }
        });
    }

    const handleClearFeedback = (record) => {
        const recordIndex = report.completed.findIndex(item => item._id === record._id);
        const updatedRecord = {
            ...record,
            evaluationFeedback: '',
            evaluationImprovement: '',
            markScored: ''
        };
        if (recordIndex !== -1) {
            const updatedEvaluated = [...report.completed];
            updatedEvaluated[recordIndex] = updatedRecord; 
            const updatedReport = {
                ...report,
                completed: updatedEvaluated
            };
            setReport(updatedReport);
            setCompletedKey(completedKey + 1);
        }

        const existingRecordIndex = modifiedData.findIndex(item => item._id === record._id);
        if (existingRecordIndex !== -1) {
            const updatedData = [...modifiedData];
            updatedData[existingRecordIndex] = {
                ...updatedData[existingRecordIndex],
                evaluationFeedback: '',
                evaluationImprovement: '',
                markScored: ''
            };
            setModifiedData(updatedData);
        } else {
            const newRecord = {
                _id: record._id,
                evaluationFeedback: '',
                evaluationImprovement: '',
                markScored: ''
            };
            setModifiedData(prevData => [...prevData, newRecord]);
        }
        setCompletedKey(completedKey + 1);
    }

    const handleSaveChanges = () => {
        setSaveLoader(true)

        const modifiedDataMap = new Map(modifiedData.map(item => [item._id, item]));

        // Merge data from selectedStudents with modifiedData if available
        const selectedModifiedData = selectedStudents.map(studentId => {
            const selectedStudentData = { _id: studentId, ...report.completed.find(item => item._id === studentId) }; // Get the complete data of the selected student
            const modifiedStudentData = modifiedDataMap.get(studentId); // Get modified data for the student

            if (modifiedStudentData) {
                const mergedData = { ...selectedStudentData, ...modifiedStudentData };
    
                if (!mergedData.evaluationStatus) {
                    mergedData.evaluationStatus = "Evaluated";
                }
                return mergedData;
            } else {
                if (!selectedStudentData.evaluationStatus) {
                    selectedStudentData.evaluationStatus = "Evaluated";
                }
                return selectedStudentData; // Return selected student data as is
            }
        });
        trackEvent("auto_evaluation_result_published", {
            ide_project_stack_name: projectType,
          });

        updateLabAssignmetReport(resourceId,labQuestionMappingId,selectedModifiedData ).then((response) => {
            response = response.data
            if (response.statusCode === 200) {
                message.success(response.message);                     
                setSaveLoader(false)
                fetchSubmittedData(completedPageNo,true)
            }
        })
    }

    const handleRowClick = (record) => {
        if (!dropdownClicked) {
            const newExpandedRowKeys = [...expandedRowKeys];
            const keyIndex = newExpandedRowKeys.indexOf(record._id);
            if (keyIndex > -1) {
                newExpandedRowKeys.splice(keyIndex, 1);
            } else {
                newExpandedRowKeys.push(record._id);
            }
            setExpandedRowKeys(newExpandedRowKeys);
        }
        setDropdownClicked(false);
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    return (
        <>
            <Row className=" fixed-top p-2" style={{backgroundColor:'#fef8f8'}}>
                <Col
                    className="col d-flex align-items-center"
                    justify="space-evenly"
                    align="middle"
                    >
                    <BackBtn/>
                    <span className="m-1 mt-2 h4 poppins-medium">AI Generated Evaluation</span>
                </Col>
                <Col className="mt-2">
                    <Button type="primary" className="create-button poppins-medium" 
                        style={{boxShadow: '0px 12px 14px rgba(233, 99, 88, 0.2)'}}
                        onClick={handleSaveChanges}
                        loading={saveLoader}
                        >Publish Reports
                    </Button>
                </Col>
            </Row>

            <Divider className="d-none d-md-block" style={{backgroundColor:"#D7BEF7", marginTop:'60px'}}/>

            <ProjectFilters
                filtersChanged={filtersChanged}
                hideUserFilter ={false} 
                hideAcademicYearFilter = {true}
                hideProjectTypeFilter = {true}
                hideDateFilter = {true}
                hideProjectNameFilter={true}
                hidePaginationFilter={true} 
                hidePendingEvaluationOption={true}
                hideClassFilter ={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true} 
                hideDivisionFilter ={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
                hideProjectStatusFilter = {true}
            />  

            <Row className='bg-white p-3 rounded-3 m-2 mt-2 d-none d-md-block'>
                <Col xs={24}>
                    <>
                        <Row>
                            <Col>
                                <span className="poppins-regular midnight-blue" style={{fontSize:'18px'}}>{questionTitle}</span>
                                <p className="poppins-regular" style={{color:'#A7A7A7'}}   > 
                                    Assigned to  
                                    <Tooltip
                                        title={renderMappings(studentMappings, false)} 
                                        overlayStyle={{
                                            maxWidth: '300px', 
                                            textAlign: 'left', 
                                            lineHeight: '1.5', 
                                        }}
                                    >
                                        <span style={{ color: '#404040', cursor: 'pointer' }}>
                                            {renderMappings(studentMappings, true)} 
                                        </span>
                                    </Tooltip>
                                 {selectedDate ? (<> on <span style={{ color: '#404040' }}>{formatDateMonth(selectedDate)}</span></>
                                  ) : null}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <div className="common-column-header">
                                    {columns.map((column, index) => {
                                        return (
                                        <div key={column.key} className={`poppins-bold column-${column.key}`} style={{ width: column.width }}>
                                            {column.title}                            
                                        </div>
                                        );
                                    })}
                                </div>
                                
                                <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2 ">
                                    <span className="poppins-bold px-4" style={{fontSize:'16px',color:'#404040',paddingRight:'8px' }}>Evaluated</span>
                                    {/* <Tag className='report-submitted-tag'>{completedDataCount?completedDataCount:0}</Tag> */}
                                    <Spin spinning={isCompletedLoading}>
                                    {report.completed && report.completed.length > 0 &&(
                                        <>
                                            <Table dataSource={report.completed} columns={columns} pagination={false}
                                                style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                                showHeader={false}
                                                key={completedKey}
                                            />
                                            <Pagination className="cs-pagination"
                                                total={completedDataCount}
                                                defaultCurrent={1}
                                                onChange={(current) => {
                                                    fetchSubmittedData(current,false)
                                                }}
                                                style={{ textAlign: 'right' }}
                                            />
                                        </>
                                    )}
                                    </Spin>
                                </div>
                                
                            </Col>
                        </Row>
                    </>
                </Col>
                <Col className="mt-2">
                    <Button type="primary" className="create-button poppins-medium" 
                        style={{boxShadow: '0px 12px 14px rgba(233, 99, 88, 0.2)'}}
                        onClick={handleSaveChanges}
                        loading={saveLoader}
                        >Publish Reports
                    </Button>
                </Col>
            </Row>

            <Divider className="d-md-none" style={{backgroundColor:"#D7BEF7", marginTop:'110px'}}/>

            <Row className=' rounded-3 m-2 mt-3 d-md-none'>
                <Col xs={24}>
                    <>
                        <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2 ">
                            <span className="poppins-bold px-2" style={{fontSize:'16px',color:'#404040',paddingRight:'8px' }}>Evaluated</span>
                            {/* <Tag className='report-submitted-tag'>{completedDataCount}</Tag> */}
                            <Spin spinning={isCompletedLoading}>
                            {report.completed && report.completed.length > 0 &&(
                                <>
                                   
                                    <Table
                                        className="mt-2"
                                        dataSource={report.completed}
                                        columns={columnsExpandable}
                                        pagination={false}
                                        style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                        showHeader={false}
                                        key={completedKey}
                                        expandable={{
                                            expandIcon: () => null,
                                            expandedRowRender: (record) => (
                                                <div>
                                                    <span className="poppins-regular" style={{fontSize:'14px', color:'#404040'}}>Feedback</span>
                                                    <Input.TextArea
                                                        value={record.evaluationFeedback}
                                                        rows={3}
                                                        onChange={(event) => handleInputChange(event.target.value, 'evaluationFeedback', record._id)}
                                                        className="mb-2"
                                                    />
                                                    <span className="poppins-regular" style={{fontSize:'14px', color:'#404040'}}>Improvement</span> 
                                                    <Input.TextArea
                                                        defaultValue={record.evaluationImprovement}
                                                        rows={3}
                                                        onChange={(event) => handleInputChange(event.target.value, 'evaluationImprovement', record._id)}
                                                    />
                                                </div>
                                            ),
                                            rowExpandable: () => true,
                                        }}
                                        rowKey="_id"
                                        expandedRowKeys={expandedRowKeys}
                                        onRow={(record) => ({
                                            onClick: (event) => {
                                                if (!event.target.closest('.ant-table-cell:last-child')) {
                                                    handleRowClick(record);
                                                }
                                            },
                                        })}
                                        rowClassName={() => 'clickable-row'}
                                    /> 

                                    <Pagination className="cs-pagination"
                                        total={completedDataCount}
                                        defaultCurrent={1}
                                        onChange={(current) => {
                                            fetchSubmittedData(current,false)
                                        }}
                                        style={{ textAlign: 'right' }}
                                    />
                                </>
                            )}
                            </Spin>
                        </div>
                    </>              
                </Col>
            </Row>
            {isOpen && (
                <SourceCodeModal
                    isOpen={isOpen}
                    handleCancel={handleCancel}
                    currentRecord={currentRecord}
                />
            )}
        </>        
    );
};

export default AIAutoBulkEvaluate;